module.exports = __webpack_public_path__ + "img/e3cc22d.png";